module.exports = __webpack_public_path__ + "852048a35700948acd842425ab4eb695.pdf";